const contactInfo = (state = {}, action) => {
    switch (action.type) {
        case 'CONTACTINFO_DATA_LOADED' : 
            return{
            ...state,
            contactInfoData : action.payload
            }
        default:
            return state
        }
  }
  export default contactInfo